import { createFileRoute, notFound } from "@tanstack/react-router";
import { DirectoryNotFound, DirectoryPage } from "@/components/directory-page";
import { getDirectoryTrade } from "@/data/directory-pages";
import { filterDirectoryProviders } from "@/lib/directory";
import { directoryHead, type DirectoryPageData } from "@/lib/directory-seo";
import { getPublicProviders } from "@/lib/public-content.functions";

export const Route = createFileRoute("/handwerkerverzeichnis/gewerk/$gewerk")({
  staticData: { sitemap: true },
  loader: async ({ params }): Promise<DirectoryPageData> => {
    const specialty = getDirectoryTrade(params.gewerk);
    if (!specialty) throw notFound();
    const { providers, unavailable } = await getPublicProviders({
      data: { type: "auftragnehmer" },
    });
    return {
      kind: "contractor",
      specialty,
      providers: filterDirectoryProviders(providers, undefined, specialty),
      unavailable,
    };
  },
  head: ({ loaderData }) => directoryHead(loaderData),
  notFoundComponent: DirectoryNotFound,
  component: Page,
});

function Page() {
  const data = Route.useLoaderData();
  return <DirectoryPage key={data.specialty!.slug} {...data} />;
}
